import moment from 'moment';

function Age(date) {
  const momentDate = moment(new Date(date));
  const today = moment();

  return today.diff(momentDate, 'years');
}

function AgeInDays(date) {
  const momentDate = moment(new Date(date));
  const today = moment();

  return today.diff(momentDate, 'days');
}

export default Age;
export { AgeInDays };